import { useCallback, useEffect } from 'react';
import { useRovoConfirmedActions } from '@atlassian/rovo-content-bridge-api-commands/hooks';
import { fg } from '@atlassian/jira-feature-gating';
import { workRefreshData } from '../../../state/actions/work/index.tsx';
import { REFRESH_SOURCE_ROVO_BROADCAST_ACTION } from '../../../model/constants.tsx';
import { useBoardDispatch } from '../../../state/index.tsx';

export function useRovoBroadcastActions(appId: string) {
	const { subscribeToConfirmedActions } = useRovoConfirmedActions(appId);
	const dispatch = useBoardDispatch();

	const onBroadcastAction = useCallback(() => {
		if (fg('rovo_broadcast_actions')) {
			dispatch(workRefreshData(REFRESH_SOURCE_ROVO_BROADCAST_ACTION));
		}
	}, [dispatch]);

	useEffect(() => {
		const unsubscribe = fg('rovo_broadcast_actions')
			? subscribeToConfirmedActions(onBroadcastAction)
			: () => undefined;
		return () => {
			unsubscribe();
		};
	}, [subscribeToConfirmedActions, onBroadcastAction]);
}
